<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Add Notify Me">
      <div class="row">
        <div class="col-md-6 form-group">
          Test
          <b-form-select v-model="test" :options="testOptions"></b-form-select>
        </div>
        <div class="col-md-6 form-group">
          User
          <b-form-select v-model="user" :options="userOptions"></b-form-select>
        </div>
        <div class="col-md-6 form-group">
          Notification Date
          <b-form-datepicker v-model=" notificationDate"></b-form-datepicker>
        </div>
      </div>
      <div class="text-center">
        <b-button
          class="text-center pt-2 pb-2 pr-4 pl-4"
          variant="success"
          style="margin-bottom: 20px"
          >Save</b-button
        >
      </div>
    </base-block>
  </div>
</template>

<script>
export default {
  data() {
    return {
         notificationDate: "",
      test: "",
      testOptions: [
        { text: "Numbers test 1" },
        { text: "Quantitative Test 2" },
        { text: "Verbal Easy" },
        { text: "Reasoning Easy " },
      ],
      user: "",
      userOptions: [
        { text: "Rasheed" },
        { text: "Partha" },
        { text: "Arun" },
        { text: "Sujith" },
        { text: "Karthi" },
        { text: "Praveen" }
      ],
    };
  },
};
</script>

